import { reactive, dispose } from './reactive.js';
import { observe } from './observe.js';
import { effect } from './effects.js';

let i = 0;

/**
 * @template T
 * @callback CreateStore
 * @param {{state: T}} param0
 * @param {{prefix?: string}} param1
 * @returns {{
 *  id:string,
 *  state: T,
 *  observe: (fn:any) => void,
 *  effect: (getValue: any, handlerOrHandlers: any) => () => void,
 *  dispose: () => void
 * }}
 */

/**
 * @template T
 * @param {{state: T}} param0
 * @param {{prefix?: string}} param1
 * @returns
 */
const createStore = ({ state }, { prefix = 'store' } = {}) => {
    state = reactive(state);

    const id = `${prefix}-${i++}`;
    const store = {
        id,
        state,
        observe: (fn) => observe(() => fn(state)),
        effect: (getValue, handlerOrHandlers) => effect(() => getValue(state), handlerOrHandlers),
        dispose: () => {
            dispose(state);
        },
    };

    return store;
};

export { createStore };
